// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"fecaf14c","141":"7ca0c12f","181":"ac54a536","356":"5cbd74a2","500":"55620986"}[chunkId] + ".chunk.css";
};